module.exports = __webpack_public_path__ + "static/media/right-leaf.10f11b00.webp";